/* empty css                              */
import t from "./td-longtail-vue-components98.js";
const s = {
  name: "DeliveryAvailabilityMail",
  props: {
    success: { type: Boolean },
    content: {
      type: Object,
      default: () => ({
        success: {
          title: "Vielen Dank!",
          copy: "Du erhälst in Kürze eine E-Mail von uns, um deine Anfrage zu bestätigen."
        },
        // eslint-disable-next-line max-len
        copy: "Gib bitte deine E-Mail-Adresse ein, damit wir dich informieren können, sobald das Produkt wieder verfügbar ist."
      })
    }
  }
};
var n = function() {
  var e = this, i = e._self._c;
  return e.success ? i("div", { staticClass: "delivery-availability-mail--success" }, [e._t("success", function() {
    return [i("p", { domProps: { innerHTML: e._s(e.content.success.title) } }), i("p", { domProps: { innerHTML: e._s(e.content.success.copy) } })];
  })], 2) : i("div", { staticClass: "delivery-availability-mail" }, [e._t("content", function() {
    return [i("p", { staticClass: "delivery-availability-mail__description", domProps: { innerHTML: e._s(e.content.copy) } })];
  }), e._t("default")], 2);
}, a = [], r = /* @__PURE__ */ t(
  s,
  n,
  a,
  !1,
  null,
  "54a32ff3"
);
const d = r.exports;
export {
  d as default
};
